import {useState} from "react";
import {Container, Button} from "reactstrap";
import _ from "../Trans";
import Config from "../Config";
import token from "../AuthToken";
import QRCode from "react-qr-code";

const submitText = _('Submit');
const qrMessage = _('Or scan this QR code');
const sendEmailText = _('Send an email');
const emailSuccessText = _('Email successfully sent');
const emailErrorText = _('Error sending email');
const publicUrl = process.env.REACT_APP_PUBLIC_URL+"?utm_medium=qr";

export default function InviteFriends({fullHeight=true}) {
    const [email, setEmail] = useState("");
    const { success, error, sendInviteEmail } = useInviteEmail(); // Importa el hook y usa sus valores


    const changeEmail = (e) => setEmail(e.target.value);

    const handleSubmit = () => {
        sendInviteEmail(email);
    };

    const style = {
        'height': fullHeight ? '900vh' : 'unset'
    }

    return (
        <Container className="mt-4 mb-4 pl-0" style={style}>
            <div className="content-section text-center">
                <div className="panel-group" id="accordion">
                    <div className="panel panel-default">
                        <div className="col-12 col-md-6 offset-md-3">
                            <div className="mb-3 h3 invite-text">{sendEmailText}</div>
                            <div className="d-flex justify-content-center w-100">
                                <input id="friend-email" type="email" className="form-control mt-0"
                                       placeholder="email@domain.com" onChange={changeEmail}/>
                                <Button color="primary" onClick={handleSubmit}>{submitText}</Button>
                            </div>
                        </div>
                        <div className="d-flex justify-content-center w-100 h3 mt-4">
                            {success ? (
                                <span id="email-success"
                                      style={{"color": "green"}}>{emailSuccessText}</span>
                            ) : ""
                            }
                            {error ? (
                                <span id="email-error" style={{"color": "red"}}>{emailErrorText}</span>
                            ) : ""
                            }
                        </div>

                        <div id="qr" className="mt-5">
                            <h2 className="h3 invite-text">{qrMessage}</h2><br/>
                            <QRCode value={publicUrl} className="mt-3"/>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    )
}

function useInviteEmail() {
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);

    const sendInviteEmail = (email) => {
        setSuccess(false);
        setError(false);

        const data = { friend_email: email };

        fetch(Config.sendInviteEmailUrl, {
            method: 'POST',
            headers: {
                Authorization: 'Token ' + token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
        .then((response) => {
            setError(response.status >= 400);
            setSuccess(response.status >= 200 && response.status < 300);
        })
        .catch(() => setError(true));
    };

    return { success, error, sendInviteEmail };
}